import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IUser } from '../../types/user/user';

export enum EUserActionTypes {
  SetUser = 'user/set',
}

export type TSetUser = ITypedReduxAction<EUserActionTypes.SetUser, IUser>;

export const setUser: (user: IUser) => TSetUser = actionGenerator<EUserActionTypes.SetUser, IUser>(
  EUserActionTypes.SetUser,
);
